import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Configs from 'config';
import { get, map } from 'lodash';
import { RootState } from 'modules';
import MenteeClassView from 'components/mentoring/mentee/MenteeClassView';
import MentorClassView from 'components/mentoring/mentor/MentorClassView';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { TMentoringClass } from 'modules/mentoring';
import { RouteMatch } from 'modules/types';
import { EUserType } from 'enums/base.enum';
import { EMentoringClassStatus } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Button, Typography, Divider } from 'antd';
import { CheckSquareOutlined, LinkOutlined, DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';

const { Text, Title } = Typography;
const ClassViewCommonWrapper = styled.div`
  .btn-default {
    background: #fff !important;
    border-color: ${PrimaryColor} !important;
    margin-left: 10px;
    height: 25px;
  }
`;

const MentoringClassView = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const match = useRouteMatch(`${ERoute.MentoringClassView}`);
  const { record_id } = (match?.params as RouteMatch) || {};

  return (
    <MentoringClassWrapper>
      {currentUser?.user_type === EUserType.Mentee ? (
        <MenteeClassView recordId={record_id} />
      ) : (
        <MentorClassView recordId={record_id} />
      )}
    </MentoringClassWrapper>
  );
};

export const ClassViewCommon = ({ record }: { record: TMentoringClass }) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const history = useHistory();
  const match = useRouteMatch(`${ERoute.MentoringClassView}`);
  const { record_id } = (match?.params as RouteMatch) || {};
  const [mentorId, setMentorId] = useState<number>();

  return (
    <ClassViewCommonWrapper>
      <div style={{ fontSize: '12px', marginTop: '10px' }}>
        <CheckSquareOutlined /> 한 개의 기기로만 접속 부탁 드립니다. 두 개 이상의 기기를 사용해 접속 시, 40분
        이후 강제 접속 종료됩니다.
      </div>
      <Divider className='class-divider-32' />
      <div style={{ marginBottom: '10px' }} className='content-title'>
        <span>멘토링의 중점 토픽</span>
        {currentUser?.user_type === EUserType.Mentee &&
          (record?.status === EMentoringClassStatus.RequestPending ||
            record?.status === EMentoringClassStatus.RequestAccepted) && (
            <Button
              className='btn-default'
              onClick={() =>
                history.push(
                  `${ERoute.MentoringClassCreate.replace(
                    ':record_id',
                    String(record?.mentor.id),
                  )}?id=${record_id}`,
                )
              }
            >
              수정
            </Button>
          )}
      </div>
      {map(get(record, 'desired_topics', []), (v) => (
        <Button className='btn-topic' style={{ marginRight: '10px' }}>
          {get(v, 'name')}
        </Button>
      ))}

      <Divider className='class-divider-32' />
      <div style={{ marginBottom: '10px' }} className='content-title'>
        <span>추가 요청사항</span>
        {currentUser?.user_type === EUserType.Mentee &&
          (record?.status === EMentoringClassStatus.RequestPending ||
            record?.status === EMentoringClassStatus.RequestAccepted) && (
            <Button
              className='btn-default'
              onClick={() =>
                history.push(
                  `${ERoute.MentoringClassCreate.replace(
                    ':record_id',
                    String(record?.mentor.id),
                  )}?id=${record_id}`,
                )
              }
            >
              수정
            </Button>
          )}
      </div>
      <div className='content-body'>{get(record, 'requirement')}</div>

      <Divider className='class-divider-32' />
      <div style={{ marginBottom: '10px' }} className='content-title'>
        <span>첨부 파일</span>
        {currentUser?.user_type === EUserType.Mentee &&
          (record?.status === EMentoringClassStatus.RequestPending ||
            record?.status === EMentoringClassStatus.RequestAccepted) && (
            <Button
              className='btn-default'
              onClick={() =>
                history.push(
                  `${ERoute.MentoringClassCreate.replace(
                    ':record_id',
                    String(record?.mentor.id),
                  )}?id=${record_id}`,
                )
              }
            >
              수정
            </Button>
          )}
      </div>
      {map(get(record, 'files', []), (v) => (
        <div style={{ margin: '5px 0px' }}>
          <LinkOutlined />
          <span style={{ fontSize: '16px', margin: '0px 10px' }}>{get(v, 'file_name')}</span>
          <Button
            type='primary'
            className='download-btn'
            href={`${Configs.API_HOST}${get(v, 'absolute_url')}`}
          >
            <DownloadOutlined />
            다운로드
          </Button>
        </div>
      ))}
    </ClassViewCommonWrapper>
  );
};

export default MentoringClassView;
